import { Component, OnInit, ViewChild, Input } from '@angular/core';
//import { PageEvent } from '@angular/material/pa';
// import { MatTableDataSource } from '@angular/material/table';
// import { MatSort} from '@angular/material';
// import { MatPaginator } from '@angular/material';
import { BookResult } from 'src/app/models/api_models/book';

export interface UserData {
  id: string;
  name: string;
  progress: string;
  color: string;
}




@Component({
  selector: 'app-book-list-table-block',
  templateUrl: './book-list-table-block.component.html',
  styleUrls: ['./book-list-table-block.component.scss']
})
export class BookListTableBlockComponent implements OnInit {


  private _oldBook : BookResult[] = [];
  get oldBook() : BookResult[] {return this._oldBook};
  set oldBook(oldBook : BookResult[])  {this._oldBook = oldBook};
  private _nextBook : BookResult[] = [];
  get nextBook() : BookResult[] {return this._nextBook};
  set nextBook(nextBook : BookResult[])  {this._nextBook = nextBook};

  private _bookList : BookResult[]= null;
  get bookList() : BookResult[] {
    return this._bookList;
  }


  @Input()
  set bookList(bookList : BookResult[]) {
    this._bookList = bookList;
    if (this._bookList !== null) {
      const d = new Date();
      for (const book of this._bookList) {
        const bookEndDate = new Date(book.enddate);
        book.enddate = bookEndDate;
        book.startdate = new Date(book.startdate);
        if (bookEndDate.getTime() >= d.getTime()) {
          this._nextBook.push(book);
        }
        else {
          this._oldBook.push(book);
        }
      }
    }
  }


  constructor() {
  }

  ngOnInit() {

  }

}
